import React, { useEffect, useState } from "react";
import "./CreateMenuSearchbar.css";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

const CreateMenuSearchbar = ({ createMenusearchText, setCreateMenuSearchText }) => {
  const handleSearchText = (e) => {
    setCreateMenuSearchText(e.target.value);
  };

  return (
    <div className="createMenuSearchInputContainer">
      <PosCustomIcon
        icon={<MagnifyingGlassIcon />}
        color={"#6B6B6B"}
        height={"1.25rem"}
        width={"1.25rem"}
      />
      <input
        type="text"
        placeholder="Search Products"
        value={createMenusearchText}
        onChange={handleSearchText}
        className="createMenuSearchInput"
      />
    </div>
  );
};

export default CreateMenuSearchbar;
